'use client'

import Image from 'next/image'
import React from 'react'
import { CMSLink } from '@/components/Link'
import { ChevronLeftIcon } from 'lucide-react'

export default function NotFound() {
  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-white">
      <div className="relative flex w-full flex-col items-center justify-center text-center">
        {/* Large 404 Text */}
        <div className="flex h-auto w-full max-w-7xl items-center justify-center md:aspect-square">
          <Image
            src="/404.png"
            alt="404"
            width={1200}
            height={1200}
            className="h-full w-full object-contain"
          />
        </div>

        {/* Content positioned inside the "0" on desktop, below on mobile */}
        <div className="absolute inset-0 hidden items-center justify-center md:block">
          <div className="max-w-[20vw] transform text-center md:absolute md:inset-0 md:flex md:max-w-none md:flex-col md:items-center md:justify-center">
            <h2
              className="mb-1 text-[clamp(0.6rem,1.7vw,1.4rem)] font-bold leading-tight text-black"
              style={{ fontSize: 'clamp(0.6rem, 1.7vw, 1.4rem)' }}
            >
              Page Not Available
            </h2>
            <p
              className="mb-2 text-[clamp(0.5rem,1.3vw,1rem)] leading-tight text-black"
              style={{ fontSize: 'clamp(0.5rem, 1.3vw, 1rem)' }}
            >
              Sorry, Da Ist Wohl <br /> Was Schief Gelaufen.
            </p>
            <CMSLink
              url="/"
              appearance="link"
              className="flex flex-row items-center gap-2 text-[clamp(0.5rem,1.3vw,1rem)]"
            >
              <ChevronLeftIcon className="h-4 w-4" /> Zurück
            </CMSLink>
          </div>
        </div>

        {/* Mobile version - positioned below the image */}
        <div className="mt-8 block px-4 md:hidden">
          <div className="text-center">
            <h2 className="mb-2 text-xl font-bold text-black">Page Not Available</h2>
            <p className="mb-4 text-base text-black">
              Sorry, Da Ist Wohl <br /> Was Schief Gelaufen.
            </p>
            <CMSLink url="/" appearance="link">
              Zurück &gt;
            </CMSLink>
          </div>
        </div>
      </div>
    </div>
  )
}
